/**
 * Converts an unknown value to a trimmed string, returning undefined for
 * non-strings, empty strings, or whitespace-only strings.
 *
 * Useful for normalizing optional string fields from untrusted JSON payloads
 * where the field may be absent, null, or a whitespace-only string.
 */
export function trimToOptionalString(value: unknown): string | undefined {
  if (typeof value !== "string") {
    return undefined;
  }

  const trimmed = value.trim();
  return trimmed || undefined;
}
